import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center gap-4" }
const _hoisted_2 = {
  key: 4,
  class: "flex justify-between items-center"
}
const _hoisted_3 = {
  class: "ml-1 tooltip",
  "data-tip": "Select on keyboard"
}
const _hoisted_4 = { class: "btn btn-sm btn-ghost" }

import { computed, ref } from "vue";
import { assertUnreachable } from "@/utils";
import {
  ConditionValue,
  ConditionTypeValue,
  CONDITION_TYPE,
  conditionType,
  isCondAlways,
  isCondLed,
  isCondRole,
  isCondUsbOn,
  isCondPressed,
  isCondKeyAction,
  isCondKeyPressed,
  isCondLayer,
  isCondBootloaderAllowed,
  isCondTypeLogic,
  KEYBOARD_LEDS,
  KEY_ACTION,
} from "@/keyboard/leds";
import { layout_bounds } from "@/keyboard/layout";
import { useKeyboardStore, useLayoutStore } from "@/stores";
import KeyCap from "@/components/keys/KeyCap.vue";
import SettingsOption from "@/components/utils/SettingsOption.vue";
import IntegerInput from "@/components/utils/IntegerInput.vue";
import ListSelect from "@/components/utils/ListSelect.vue";
import PopupButton from "@/components/utils/PopupButton.vue";
import { KeyAction } from "@/keyboard";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionTypeEdit',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const kb = useKeyboardStore();
const layout = useLayoutStore();

const popupButton = ref<InstanceType<typeof PopupButton> | null>(null);

const cond = computed(() => props.modelValue);

const size = { width: 600, height: 2000 };
const keys = computed(() => {
  const transform = layout.layout.fit_size({
    x: size.width,
    y: size.height,
  });
  return layout.layout.iter_transform(transform);
});

const area_size = computed(() => {
  const [area_min, area_max] = layout_bounds(keys.value);
  const area_width = area_max.x - area_min.x;
  const area_height = area_max.y - area_min.y;
  return {
    x: area_width,
    y: area_height,
  };
});

const area_width = computed(() => area_size.value.x);
const area_height = computed(() => area_size.value.y);

const DEFAULTS: Record<ConditionTypeValue, ConditionValue> = {
  Always: "Always",
  Led: { Led: "CapsLock" },
  UsbOn: "UsbOn",
  Role: { Role: "Master" },
  Pressed: "Pressed",
  KeyAction: { KeyAction: "Trans" },
  // TODO: warn about invalid key/layer
  KeyPressed: { KeyPressed: [0, 0] },
  Layer: { Layer: 0 },
  BootloaderAllowed: "BootloaderAllowed",
};

const keyActionText = (a: KeyAction): string =>
  a == "Trans"
    ? "Transparent"
    : a == "DefaultLayer"
    ? "Default Layer"
    : a == "MultipleActions"
    ? "Multiple Actions"
    : a == "MultipleKeyCodes"
    ? "Multiple Keycodes"
    : a;

const updateConditionType = (c: ConditionTypeValue) =>
  emit("update:modelValue", DEFAULTS[c]);

const keySelected = (row: number, col: number) => {
  if (isCondKeyPressed(cond.value)) {
    emit("update:modelValue", { KeyPressed: [row, col] });
    popupButton.value?.show(false);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SettingsOption, {
      label: "Condition",
      tooltip: "Condition required to make the rule active",
      class: "w-auto",
      labelClass: "justify-start"
    }, {
      default: _withCtx(() => [
        _createVNode(ListSelect, {
          class: "w-52",
          modelValue: _unref(conditionType)(cond.value),
          "onUpdate:modelValue": updateConditionType,
          options: _unref(CONDITION_TYPE).filter((c) => !_unref(isCondTypeLogic)(c)),
          clearable: false
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }),
    (
        _unref(isCondAlways)(cond.value) ||
        _unref(isCondUsbOn)(cond.value) ||
        _unref(isCondPressed)(cond.value) ||
        _unref(isCondBootloaderAllowed)(cond.value)
      )
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
      : (_unref(isCondLed)(cond.value))
        ? (_openBlock(), _createBlock(SettingsOption, {
            key: 1,
            class: "w-full",
            label: "Led",
            tooltip: "Applies this rule if host PC specifies that given LED is on"
          }, {
            default: _withCtx(() => [
              _createVNode(ListSelect, {
                class: "min-w-[15ch] w-full",
                options: _unref(KEYBOARD_LEDS),
                modelValue: cond.value.Led,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cond.value.Led) = $event)),
                clearable: false
              }, null, 8, ["options", "modelValue"])
            ]),
            _: 1
          }))
        : (_unref(isCondRole)(cond.value))
          ? (_openBlock(), _createBlock(SettingsOption, {
              key: 2,
              class: "w-full",
              label: "Role",
              tooltip: "Apply if the keyboard half has given role"
            }, {
              default: _withCtx(() => [
                _createVNode(ListSelect, {
                  class: "min-w-[14ch] w-full",
                  options: ['Master', 'Slave'],
                  modelValue: cond.value.Role,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((cond.value.Role) = $event)),
                  clearable: false
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : (_unref(isCondKeyAction)(cond.value))
            ? (_openBlock(), _createBlock(SettingsOption, {
                key: 3,
                class: "w-full",
                label: "Action",
                tooltip: "Apply to keys with given action type"
              }, {
                default: _withCtx(() => [
                  _createVNode(ListSelect, {
                    class: "min-w-[21ch] w-full",
                    options: _unref(KEY_ACTION),
                    modelValue: cond.value.KeyAction,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cond.value.KeyAction) = $event)),
                    clearable: false,
                    getOptionLabel: keyActionText
                  }, null, 8, ["options", "modelValue"])
                ]),
                _: 1
              }))
            : (_unref(isCondKeyPressed)(cond.value))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "px-2" }, "Row", -1)),
                  _createVNode(IntegerInput, {
                    class: "w-[6ch] input-sm",
                    min: 0,
                    max: _unref(kb).rows - 1,
                    modelValue: cond.value.KeyPressed[0],
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cond.value.KeyPressed[0]) = $event))
                  }, null, 8, ["max", "modelValue"]),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "px-2" }, "Col", -1)),
                  _createVNode(IntegerInput, {
                    class: "w-[6ch] input-sm",
                    min: 0,
                    max: _unref(kb).columns - 1,
                    modelValue: cond.value.KeyPressed[1],
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((cond.value.KeyPressed[1]) = $event))
                  }, null, 8, ["max", "modelValue"]),
                  _createVNode(PopupButton, {
                    ref_key: "popupButton",
                    ref: popupButton,
                    placement: "auto",
                    offset: 3
                  }, {
                    button: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_Icon, { icon: "material-symbols:keyboard-alt-outline" })
                        ])
                      ])
                    ]),
                    popup: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "relative m-4",
                        style: _normalizeStyle({ width: area_width.value + 'px', height: area_height.value + 'px' })
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keys.value, (k, id) => {
                          return (_openBlock(), _createBlock(KeyCap, {
                            key: id,
                            row: k.row,
                            col: k.col,
                            x: k.key.x,
                            y: k.key.y,
                            rot: k.key.rot,
                            height: k.key.size.y,
                            width: k.key.size.x,
                            blank: true,
                            outlined: 
                  cond.value.KeyPressed[0] == k.row && cond.value.KeyPressed[1] == k.col
                ,
                            onClick: ($event: any) => (keySelected(k.row, k.col))
                          }, null, 8, ["row", "col", "x", "y", "rot", "height", "width", "outlined", "onClick"]))
                        }), 128))
                      ], 4)
                    ]),
                    _: 1
                  }, 512)
                ]))
              : (_unref(isCondLayer)(cond.value))
                ? (_openBlock(), _createBlock(SettingsOption, {
                    key: 5,
                    class: "w-full",
                    label: "Layer",
                    tooltip: "Apply when on a given layer"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ListSelect, {
                        class: "min-w-[12ch] w-full",
                        options: _unref(kb).availableLayers,
                        modelValue: cond.value.Layer,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((cond.value.Layer) = $event)),
                        clearable: false
                      }, null, 8, ["options", "modelValue"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    _createTextVNode(_toDisplayString(_unref(assertUnreachable)(cond.value)), 1)
                  ], 64))
  ]))
}
}

})